import { __extends, __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import MaskedField from '../MaskedField/index.js';
import mask from './mask.js';

var PhoneField =
/** @class */
function (_super) {
  __extends(PhoneField, _super);

  function PhoneField(props) {
    var _this = _super.call(this, props) || this;

    if (props.value) {
      throw new Error('Passing a value argument to the MaskedField breaks the phone mask, use `defaultValue` to make this uncontrolled');
    }

    _this.cleanPhoneNumber = _this.cleanPhoneNumber.bind(_this);
    return _this;
  }

  PhoneField.prototype.cleanPhoneNumber = function (phone) {
    // Convert to string
    if (Array.isArray(phone)) {
      phone = phone.join('');
    } // Naive attempt at stripping the country code


    if (phone.length === 12 && phone.startsWith('+1')) {
      phone = phone.slice(2);
    } else if (phone.length === 11 && phone.startsWith('1')) {
      phone = phone.slice(1);
    } // Strip whitespace, parens, pluses, underscores and dashes


    phone = phone.replace(/[\s\(\)\+\-\_]/g, '');
    return phone;
  };

  PhoneField.prototype.render = function () {
    var _a = this.props,
        maskedFieldProps = _a.maskedFieldProps,
        defaultValue = _a.defaultValue,
        rest = __rest(_a, ["maskedFieldProps", "defaultValue"]);

    var cleanedValue = defaultValue && this.cleanPhoneNumber(defaultValue);
    return React.createElement(MaskedField, __assign({
      type: "tel",
      maskedFieldProps: __assign({
        mask: mask,
        guide: false
      }, maskedFieldProps),
      defaultValue: cleanedValue
    }, rest));
  };

  PhoneField.defaultProps = {
    autoFocus: false,
    placeholder: 'Enter a phone number'
  };
  return PhoneField;
}(React.Component);

export default PhoneField;
//# sourceMappingURL=index.js.map
